import { Body, Box, Container, Heading } from '@hover/blueprint';
import React, { FunctionComponent, useState } from 'react';
import { DownloadAppModal } from '..';
import ArrowButton from '../../ui/ArrowButton';

export interface ReadyToSeePossibilitesProps {
  body: string;
}

const ReadyToSeePossibilities: FunctionComponent<ReadyToSeePossibilitesProps> =
  ({ body }) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const toggleModal = () => setIsOpen(!isOpen);

    return (
      <Box w="100%" bg="brandNavy.500" py={1000}>
        <DownloadAppModal isOpen={isOpen} onClose={toggleModal} />
        <Container maxW="3xl" px={{ base: 500, tablet: 0 }} centerContent>
          <Heading
            textAlign="center"
            size={{ base: 500, tablet: 600, desktop: 700 }}
            style={{ color: 'white', marginBottom: 24, fontWeight: 700 }}
          >
            Ready to see the possibilities?
          </Heading>
          <Heading
            mb={700}
            isDisplay
            size={500}
            textAlign="center"
            color="neutral.0"
            style={{ marginBottom: 40 }}
            d={{ base: 'none', tablet: 'flex' }}
            maxW={{ base: '100%', tablet: '80%' }}
          >
            {body}
          </Heading>
          <Body
            d={{ base: 'flex', tablet: 'none' }}
            size={500}
            mb={700}
            textAlign="center"
            color="neutral.0"
          >
            {body}
          </Body>
          <ArrowButton
            colorScheme="brandNavy"
            variant="inverted"
            onClick={() => toggleModal()}
            w={{ base: '100%', tablet: 'auto' }}
          >
            Try for Free
          </ArrowButton>
        </Container>
      </Box>
    );
  };

export default ReadyToSeePossibilities;
